import React, { useEffect, useState } from "react";
import { products } from "../../../../dictionaries/products";
import { Product } from "../../../../services/useReportsDetailGet";
import styles from "./DashboardReport.module.scss";
import ProductReport from "./ProductReport";

interface ProductReport {
  icon: string;
  label: string;
  product: Product;
}

const DashboardReport = () => {

  const [activated, setActivated] = useState(false);
  useEffect(() => {
    const element = document.getElementById("dashboard_report");
    const handleActivate = () => {
      setActivated(true);
    };
    if (element) {
      element.addEventListener("activateDashboardReport", handleActivate);
    }
    return () => {
      if (element) {
        element.removeEventListener("activateDashboardReport", handleActivate);
      }
    };
  }, []);
  return (
    <div id="dashboard_report" className="eb-card" style={{ scrollMarginTop: "5.25rem" }}>
      <div className={styles.container}>
        {products.map(product => (
          <ProductReport
            key={product}
            product={product}
            activated={activated}
          />
        ))}
      </div>
    </div>
  )
}

export default DashboardReport;